import React, { useMemo } from 'react';
import { Box, Dialog, DialogContent, Button, Divider } from '@material-ui/core';

import { TicketsContent } from './TicketsContent';
import { OptionsContent } from './OptionsContent';
import { SchedulesContent } from './SchedulesContent';
import { useCalendarAutocomplete } from 'src/hooks/autocompletes/useCalendarAutocomplete';
import { useSelector } from 'react-redux';
import { calendarOptions, tripData } from 'src/redux/Calendar/sliceCalendar';
import { Spiner } from '../../Loaders/Spiner/Spiner';
import { useStyles } from './styles';

export const CalendarDetailsDialog = ({
  open,
  onClose,
  loading,
  updateLoading,
  applyChanges,
}: {
  open: boolean;
  loading: boolean;
  updateLoading: boolean;
  onClose: () => void;
  applyChanges: () => void;
}) => {
  const classes = useStyles();
  const { tripList } = useCalendarAutocomplete();
  const { rate_id, type, option_type, ticket_type, trip_id } =
    useSelector(calendarOptions);
  const data = useSelector(tripData);
  const trip = tripList.find((i) => i.id === trip_id);
  const comission = trip?.comission || '';

  const content = useMemo(() => {
    //const partnerName = trip?.partner_name || '';
    const tripName = data?.name || '';
    const rateName = data?.rates.find((i) => i.id === rate_id)?.name || '';
    const ticketName =
      data?.tickets.find((i) => i.id === ticket_type)?.name || '';
    const optionName =
      data?.additional_options.find((i) => i.id === option_type)?.name || '';

    return (
      <Box mr="auto">
        <Box style={{ fontSize: '16px' }}>
          {type === 'ticket' && (
            <>
              Detailed setup of the <strong>"{ticketName}"</strong> ticket
            </>
          )}
          {type === 'option' && (
            <>
              Detailed setup of the additional option{' '}
              <strong>"{optionName}"</strong>
            </>
          )}
          {type === 'schedule' && (
            <>
              Detailed setup of the <strong>schedules</strong> ticket
            </>
          )}
        </Box>
        <Box>
          trip: <strong>{tripName}</strong>
          {!!rateName && <>, rate: {rateName}</>}
        </Box>
      </Box>
    );
  }, [
    data?.additional_options,
    data?.name,
    data?.rates,
    data?.tickets,
    option_type,
    rate_id,
    ticket_type,
    trip?.partner_name,
    type,
  ]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <Box
        display="flex"
        justifyContent="flex-end"
        flexWrap="wrap"
        gridGap="16px"
        py={2}
        px={3}>
        <>{content}</>
        <Button
          className={classes.cancelButton}
          style={{ marginRight: '8px' }}
          variant="outlined"
          onClick={onClose}
          color="default">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.saveButton}
          onClick={applyChanges}>
          Apply changes
        </Button>
      </Box>
      <Divider variant="fullWidth" />
      <DialogContent className="customScroll" style={{ padding: 0 }}>
        {loading && <Spiner />}
        {updateLoading && <Spiner />}
        {type === 'ticket' && <TicketsContent comission={comission} />}
        {type === 'option' && <OptionsContent />}
        {type === 'schedule' && <SchedulesContent />}
      </DialogContent>
    </Dialog>
  );
};
